import { Cancel, Close } from "@mui/icons-material";
import {
  Box,
  IconButton,
  Modal as ModalMui,
  ModalProps,
  SxProps,
  Theme
} from "@mui/material";
import React, { useEffect } from "react";
export const Modal: React.FC<ModalProps & { onClose: () => void, innerSx?: SxProps }> = (
  props
) => {
  useEffect(() => {
    function handleEscape(event: any) {
      if (event.key === "Escape") {
        props.onClose();
      }
    }

    window.addEventListener("keydown", handleEscape);

    return () => {
      window.removeEventListener("keydown", handleEscape);
    };
  }, [props]);
  //@ts-ignore
  const sx: SxProps = props.sx ? { ...modalStyle, ...props.sx } : modalStyle;
  return (
    <ModalMui hideBackdrop {...props} sx={sx}>
      <Box width="fit-content" sx={props.innerSx} style={{outline: "none"}}>
        <Box
          sx={{ display: "flex", justifyContent: "flex-end", flex: 1 }}
        >
          <IconButton onClick={props.onClose}>
            <Close sx={{ color: "white", fontSize: 32 }} />
          </IconButton>
        </Box>
        {props.children}
      </Box>
    </ModalMui>
  );
};

const modalStyle: SxProps = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  minWidth: 600,
  minHeight: 800,
  maxWidth: "80vw",
  maxHeight: "80vh",
  overflow: "hidden",
  boxShadow: 24,
  p: 1,
  textAlign: "center",
  background: "#0f0d1e",
  borderRadius: 2,
  alignItems: 'center',
  outline: "none"
};
